exports.setTitle = title => {
  document.title = title ? `DE Portal | ${title}` : 'Data Energy Portal';
};

exports.scrollTop = () => setTimeout(() => window.scrollTo(0, 0), 250);



// WEBPACK FOOTER //
// ./src/utils/misc.js